import store from "@builder/store/store";
import { buildSettingsApi } from "./buildSettingsApi";
import { BuildSettings } from "@builder/types/BuildSettings";
import { BaseLayerTypes, Build, BuildNode } from "@common/build/types";

const hasPaymentGrid = (build: Partial<Build>) => {
    for (const layerType of Object.values(BaseLayerTypes)) {
        const layerGroup = build?.[layerType];
        if (layerGroup && Array.isArray(layerGroup)) {
            for (const baseLayer of layerGroup) {
                if (Object.values(baseLayer.components).some((node: BuildNode) => node.name === "paymentGrid")) {
                    return true;
                }
            }
        }
    }
    return false;
};

export const updatePaymentGrid = async (build: Partial<Build>, companyId: string) => {
    try {
        if (build.id) {
            const buildSettings = await store
                .dispatch(buildSettingsApi.endpoints.getBuildSettings.initiate({ companyId, buildId: build.id }))
                .unwrap();
            const paymentGridSetting = buildSettings?.find((setting: BuildSettings) => setting.key === "buildSettingsKey.hasPaymentGrid");
            if (paymentGridSetting) {
                await store.dispatch(
                    buildSettingsApi.endpoints.updateBuildSettings.initiate({
                        companyId,
                        id: paymentGridSetting._id,
                        buildSettings: { value: String(hasPaymentGrid(build)) }
                    })
                );
            } else {
                await store.dispatch(
                    buildSettingsApi.endpoints.createBuildSettings.initiate({
                        companyId,
                        buildSettings: { key: "buildSettingsKey.hasPaymentGrid", companyId, buildId: build.id, value: String(hasPaymentGrid(build)) }
                    })
                );
            }
        }
    } catch (error) {
        console.log("Error updating payment grid", error);
    }
};
